import { AxiosRequestConfig, AxiosResponse } from "axios";
import { HttpClient, TimeMeasure, IHttpRequestable } from "../utilities";

export class AuthenticatedHttpClient implements IHttpRequestable {
  constructor(private readonly _getToken: () => string, logger: (m: string) => void = TimeMeasure.debug) {
    this._client = new HttpClient(logger);
  }

  private readonly _client: HttpClient;

  async get<T = any>(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return this._client.get(
      url,
      this.toAuthorizedConfig(config),
    );
  }

  async post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return this._client.post(
      url,
      data,
      this.toAuthorizedConfig(config),
    );
  }

  private toAuthorizedConfig(config?: AxiosRequestConfig): AxiosRequestConfig {
    const result = config ? config : {};
    result.params = result.params ? result.params : {};
    // result.params.token = this.token;
    result.headers = result.headers ? result.headers : {};
    result.headers.Authorization = "Bearer " + this.token;
    return result;
  }

  public get token(): string {
    const token = this._getToken();
    if ((token === undefined || token === null || token === "")) {
      throw new Error("token is empty!!!");
    }
    return token;
  }
}
